export const removeCache = () => {
  localStorage.removeItem('walletconnect')
}
